/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  display: block;
  max-inline-size: 100%;
  cursor: pointer;
  color: var(--calcite-color-text-3);
}

.node-actions-container {
  display: flex;
}

:host([calcite-hydrated-hidden]) {
  visibility: hidden !important;
  pointer-events: none;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host([scale=s]) {
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
}
:host([scale=s]) .node-actions-container {
  min-block-size: 1.5rem;
}
:host([scale=s]) .node-actions-container .node-container .checkbox,
:host([scale=s]) .node-actions-container .node-container .checkmark,
:host([scale=s]) .node-actions-container .node-container .bullet-point {
  margin-inline: 0.25rem;
}
:host([scale=s]) .node-actions-container .node-container .icon-start {
  margin-inline: 0.75rem;
}
:host([scale=s]) .node-actions-container .node-container .chevron {
  padding: 0.25rem;
}

:host([scale=m]) {
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
}
:host([scale=m]) .node-actions-container {
  min-block-size: 2rem;
}
:host([scale=m]) .node-actions-container .node-container .checkbox,
:host([scale=m]) .node-actions-container .node-container .checkmark,
:host([scale=m]) .node-actions-container .node-container .bullet-point {
  margin-inline: 0.5rem;
}
:host([scale=m]) .node-actions-container .node-container .icon-start {
  margin-inline: 0.75rem;
}
:host([scale=m]) .node-actions-container .node-container .chevron {
  padding: 0.5rem;
}

:host([scale=l]) {
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
}
:host([scale=l]) .node-actions-container {
  min-block-size: 2.75rem;
}
:host([scale=l]) .node-actions-container .node-container .checkbox,
:host([scale=l]) .node-actions-container .node-container .checkmark,
:host([scale=l]) .node-actions-container .node-container .bullet-point {
  margin-inline: 0.75rem;
}
:host([scale=l]) .node-actions-container .node-container .icon-start {
  margin-inline: 0.75rem;
}
:host([scale=l]) .node-actions-container .node-container .chevron {
  padding-inline: var(--calcite-size-md);
  padding-block: var(--calcite-size-sm-plus);
}

:host([lines]) .children-container::after {
  position: absolute;
  inset-block-start: 0px;
  z-index: var(--calcite-z-index);
  inline-size: 1px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  block-size: 96%;
  content: "";
  background-color: var(--calcite-color-border-2);
}

:host(:not([lines])) .node-container::after {
  display: none;
}

::slotted(*) {
  min-inline-size: 0px;
  max-inline-size: 100%;
  overflow-wrap: break-word;
  color: inherit;
  text-decoration: none !important;
}
::slotted(*):hover {
  text-decoration: none !important;
}

::slotted(a) {
  inline-size: 100%;
  text-decoration-line: none;
}

:host {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:host .node-container {
  outline-color: transparent;
}
:host:focus .node-container, :host:active .node-container {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

:host(:focus:not([disabled])) .node-container {
  outline: 2px solid transparent;
  outline-offset: 2px;
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}
:host(:focus:not([disabled])) .checkbox {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.actions-end {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.checkbox-container {
  display: flex;
  align-items: center;
}

.checkbox {
  line-height: 0;
  color: var(--calcite-color-border-input);
}

.checkbox-label {
  pointer-events: none;
  display: flex;
  align-items: center;
}

.children-container {
  position: relative;
  block-size: 0px;
  transform-origin: top;
  overflow: hidden;
  opacity: 0;
  margin-inline-start: 1.25rem;
  transform: scaleY(0);
  transition: var(--calcite-animation-timing) cubic-bezier(0.215, 0.44, 0.42, 0.88), opacity var(--calcite-animation-timing) cubic-bezier(0.215, 0.44, 0.42, 0.88), all var(--calcite-animation-timing) ease-in-out;
}
.item--expanded > .children-container {
  overflow: visible;
  opacity: 1;
  transform: none;
  block-size: auto;
}

.node-container {
  position: relative;
  display: flex;
  min-inline-size: 0px;
  flex-grow: 1;
  align-items: center;
}
.node-container .checkmark,
.node-container .bullet-point {
  opacity: 0;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  color: var(--calcite-color-border-1);
}

.node-container:hover .checkmark,
.node-container:hover .bullet-point,
:host([selected]) .node-container:hover .checkmark,
:host([selected]) .node-container:hover .bullet-point,
:host(:focus:not([disabled])) .node-container .checkmark,
:host(:focus:not([disabled])) .node-container .bullet-point {
  opacity: 1;
}

:host([selected]) .node-container,
:host([selected]) .node-container:hover {
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-1);
}
:host([selected]) .node-container .bullet-point,
:host([selected]) .node-container .checkmark,
:host([selected]) .node-container:hover .bullet-point,
:host([selected]) .node-container:hover .checkmark {
  opacity: 1;
  color: var(--calcite-color-brand);
}

:host([selection-mode=none]:not([has-children])):host([scale=s]) .node-container {
  padding-inline-start: 0.5rem;
}
:host([selection-mode=none]:not([has-children])):host([scale=m]) .node-container {
  padding-inline-start: 1rem;
}
:host([selection-mode=none]:not([has-children])):host([scale=l]) .node-container {
  padding-inline-start: 1.5rem;
}

:host(:not([has-children])):host([scale=s]) .node-container[data-selection-mode=ancestors] .checkbox {
  padding-inline-start: 1.25rem;
}
:host(:not([has-children])):host([scale=m]) .node-container[data-selection-mode=ancestors] .checkbox {
  padding-inline-start: 1.5rem;
}
:host(:not([has-children])):host([scale=l]) .node-container[data-selection-mode=ancestors] .checkbox {
  padding-inline-start: 1.75rem;
}

:host([has-children]) .node-container[data-selection-mode=ancestors] .checkbox {
  margin-inline-start: 0;
}

:host([has-children]) .node-container .bullet-point,
:host([has-children]) .node-container .checkmark {
  display: none;
}

.chevron {
  position: relative;
  align-self: center;
  color: var(--calcite-color-text-3);
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  flex: 0 0 auto;
  transform: rotate(0deg);
}
.calcite--rtl .chevron {
  transform: rotate(180deg);
}
.item--expanded .node-container > .chevron {
  transform: rotate(90deg);
}

:host([selected]) .checkmark,
:host([selected]) .bullet-point {
  color: var(--calcite-color-brand);
}
:host([selected]) .checkbox {
  color: var(--calcite-color-brand);
}

:host([has-children][indeterminate]) .checkbox {
  color: var(--calcite-color-brand);
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}